import { ApexOptions } from "apexcharts";
import { DollarSign, FileText, ShoppingBag, Users } from "react-feather";

const primary = "var(--theme-default)";
const secondary = "var(--theme-secondary)";

//Sales Chart
export const SalesChart: ApexOptions = {
  series: [
    {
      name: "Statistics",
      data: [20, 60, 50, 70, 40, 80, 20],
    },
    {
      name: "Statistics",
      data: [80, 40, 50, 30, 60, 20, 20],
    },
  ],
  chart: {
    type: "bar",
    height: 100,
    stacked: true,
    stackType: "100%",
    toolbar: {
      show: false,
    },
  },
  plotOptions: {
    bar: {
      horizontal: false,
      columnWidth: "40px",
      borderRadius: 2,
    },
  },
  grid: {
    show: false,
    xaxis: {
      lines: {
        show: false,
      },
    },
    padding: {
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
    },
  },
  states: {
    hover: {
      filter: {
        type: "darken",
      },
    },
  },
  dataLabels: {
    enabled: false,
  },
  legend: {
    show: false,
  },
  colors: [primary, "#1a5f7f1a "],
  xaxis: {
    labels: {
      show: false,
    },
    axisBorder: {
      show: false,
    },
    axisTicks: {
      show: false,
    },
  },
  yaxis: {
    labels: {
      show: false,
    },
  },
  tooltip: {
    marker: {
      show: false,
    },
    fixed: {
      enabled: false,
      position: "bottomRight",
      offsetX: 0,
      offsetY: 0,
    },
  },
  responsive: [
    {
      breakpoint: 992,
      options: {
        chart: {
          width: 200,
        },
      },
    },
    {
      breakpoint: 915,
      options: {
        chart: {
          width: 160,
        },
      },
    },
    {
      breakpoint: 848,
      options: {
        chart: {
          width: 140,
        },
      },
    },
    {
      breakpoint: 816,
      options: {
        chart: {
          width: 120,
        },
      },
    },
    {
      breakpoint: 770,
      options: {
        chart: {
          width: 100,
        },
      },
    },
    {
      breakpoint: 720,
      options: {
        chart: {
          width: 80,
        },
      },
    },
    {
      breakpoint: 576,
      options: {
        chart: {
          width: 190,
        },
      },
    },
    {
      breakpoint: 440,
      options: {
        chart: {
          width: 150,
        },
      },
    },
    {
      breakpoint: 400,
      options: {
        chart: {
          width: 130,
        },
      },
    },
    {
      breakpoint: 355,
      options: {
        chart: {
          width: 100,
        },
      },
    },
  ],
};

//Income Chart
export const IncomeChart: ApexOptions = {
  series: [
    {
      name: "Statistics",
      data: [20, 60, 50, 70, 40, 80, 20],
    },
    {
      name: "Statistics",
      data: [80, 40, 50, 30, 60, 20, 20],
    },
  ],
  chart: {
    type: "bar",
    height: 100,
    stacked: true,
    stackType: "100%",
    toolbar: {
      show: false,
    },
  },
  plotOptions: {
    bar: {
      horizontal: false,
      columnWidth: "40px",
      borderRadius: 2,
    },
  },
  grid: {
    show: false,
    xaxis: {
      lines: {
        show: false,
      },
    },
    padding: {
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
    },
  },
  states: {
    hover: {
      filter: {
        type: "darken",
      },
    },
  },
  dataLabels: {
    enabled: false,
  },
  legend: {
    show: false,
  },
  colors: [secondary, "#dd70311a"],
  xaxis: {
    labels: {
      show: false,
    },
    axisBorder: {
      show: false,
    },
    axisTicks: {
      show: false,
    },
  },
  yaxis: {
    labels: {
      show: false,
    },
  },
  tooltip: {
    marker: {
      show: false,
    },
    fixed: {
      enabled: false,
      position: "bottomRight",
      offsetX: 0,
      offsetY: 0,
    },
  },
  responsive: [
    {
      breakpoint: 992,
      options: {
        chart: {
          width: 200,
        },
      },
    },
    {
      breakpoint: 915,
      options: {
        chart: {
          width: 160,
        },
      },
    },
    {
      breakpoint: 848,
      options: {
        chart: {
          width: 140,
        },
      },
    },
    {
      breakpoint: 816,
      options: {
        chart: {
          width: 120,
        },
      },
    },
    {
      breakpoint: 770,
      options: {
        chart: {
          width: 100,
        },
      },
    },
    {
      breakpoint: 720,
      options: {
        chart: {
          width: 80,
        },
      },
    },
    {
      breakpoint: 576,
      options: {
        chart: {
          width: 190,
        },
      },
    },
    {
      breakpoint: 440,
      options: {
        chart: {
          width: 150,
        },
      },
    },
    {
      breakpoint: 400,
      options: {
        chart: {
          width: 130,
        },
      },
    },
    {
      breakpoint: 355,
      options: {
        chart: {
          width: 100,
        },
      },
    },
  ],
};

//Order Chart
export const OrderChart: ApexOptions = {
  series: [
    {
      name: "Statistics",
      data: [20, 60, 50, 70, 40, 80, 20],
    },
    {
      name: "Statistics",
      data: [80, 40, 50, 30, 60, 20, 20],
    },
  ],
  chart: {
    type: "bar",
    height: 100,
    stacked: true,
    stackType: "100%",
    toolbar: {
      show: false,
    },
  },
  plotOptions: {
    bar: {
      horizontal: false,
      columnWidth: "40px",
      borderRadius: 2,
    },
  },
  grid: {
    show: false,
    xaxis: {
      lines: {
        show: false,
      },
    },
    padding: {
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
    },
  },
  states: {
    hover: {
      filter: {
        type: "darken",
      },
    },
  },
  dataLabels: {
    enabled: false,
  },
  legend: {
    show: false,
  },
  colors: ["#da9817", "#da98171a"],
  xaxis: {
    labels: {
      show: false,
    },
    axisBorder: {
      show: false,
    },
    axisTicks: {
      show: false,
    },
  },
  yaxis: {
    labels: {
      show: false,
    },
  },
  tooltip: {
    marker: {
      show: false,
    },
    fixed: {
      enabled: false,
      position: "bottomRight",
      offsetX: 0,
      offsetY: 0,
    },
  },
  responsive: [
    {
      breakpoint: 992,
      options: {
        chart: {
          width: 200,
        },
      },
    },
    {
      breakpoint: 915,
      options: {
        chart: {
          width: 160,
        },
      },
    },
    {
      breakpoint: 848,
      options: {
        chart: {
          width: 140,
        },
      },
    },
    {
      breakpoint: 816,
      options: {
        chart: {
          width: 120,
        },
      },
    },
    {
      breakpoint: 770,
      options: {
        chart: {
          width: 100,
        },
      },
    },
    {
      breakpoint: 720,
      options: {
        chart: {
          width: 80,
        },
      },
    },
    {
      breakpoint: 576,
      options: {
        chart: {
          width: 190,
        },
      },
    },
    {
      breakpoint: 440,
      options: {
        chart: {
          width: 150,
        },
      },
    },
    {
      breakpoint: 400,
      options: {
        chart: {
          width: 130,
        },
      },
    },
    {
      breakpoint: 355,
      options: {
        chart: {
          width: 100,
        },
      },
    },
  ],
};

// Visitor Chart
export const VisitorChart: ApexOptions = {
  series: [
    {
      name: "Statistics",
      data: [20, 60, 50, 70, 40, 80, 20],
    },
    {
      name: "Statistics",
      data: [80, 40, 50, 30, 60, 20, 20],
    },
  ],
  chart: {
    type: "bar",
    height: 100,
    stacked: true,
    stackType: "100%",
    toolbar: {
      show: false,
    },
  },
  plotOptions: {
    bar: {
      horizontal: false,
      columnWidth: "40px",
      borderRadius: 2,
    },
  },
  grid: {
    show: false,
    xaxis: {
      lines: {
        show: false,
      },
    },
    padding: {
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
    },
  },
  states: {
    hover: {
      filter: {
        type: "darken",
      },
    },
  },
  dataLabels: {
    enabled: false,
  },
  legend: {
    show: false,
  },
  colors: ["#0ea4ba", "#0ea4ba1a"],
  xaxis: {
    labels: {
      show: false,
    },
    axisBorder: {
      show: false,
    },
    axisTicks: {
      show: false,
    },
  },
  yaxis: {
    labels: {
      show: false,
    },
  },
  tooltip: {
    marker: {
      show: false,
    },
    fixed: {
      enabled: false,
      position: "bottomRight",
      offsetX: 0,
      offsetY: 0,
    },
  },
  responsive: [
    {
      breakpoint: 992,
      options: {
        chart: {
          width: 200,
        },
      },
    },
    {
      breakpoint: 915,
      options: {
        chart: {
          width: 160,
        },
      },
    },
    {
      breakpoint: 848,
      options: {
        chart: {
          width: 140,
        },
      },
    },
    {
      breakpoint: 816,
      options: {
        chart: {
          width: 120,
        },
      },
    },
    {
      breakpoint: 770,
      options: {
        chart: {
          width: 100,
        },
      },
    },
    {
      breakpoint: 720,
      options: {
        chart: {
          width: 80,
        },
      },
    },
    {
      breakpoint: 576,
      options: {
        chart: {
          width: 190,
        },
      },
    },
    {
      breakpoint: 440,
      options: {
        chart: {
          width: 150,
        },
      },
    },
    {
      breakpoint: 400,
      options: {
        chart: {
          width: 130,
        },
      },
    },
    {
      breakpoint: 355,
      options: {
        chart: {
          width: 100,
        },
      },
    },
  ],
};

export const CustomerTransaction: ApexOptions = {
  series: [
    {
      type: "bar",
      data: [300, 700, 200, 400, 570, 300, 700, 400],
    },
    {
      type: "bar",
      data: [500, 500, 280, 300, 400, 190, 500, 300],
    },
    {
      type: "line",
      data: [300, 700, 200, 400, 570, 300, 700, 400],
    },
  ],
  chart: {
    height: 315,
    toolbar: {
      show: false,
    },
  },
  markers: {
    size: 6,
    strokeWidth: 3,
    offsetX: -3,
    strokeOpacity: 1,
    fillOpacity: 1,
    hover: {
      size: 6,
    },
  },
  plotOptions: {
    bar: {
      columnWidth: "60%",
      borderRadius: 6,
      dataLabels: {
        position: "top",
      },
    },
  },
  grid: {
    show: true,
    strokeDashArray: 5,
    position: "back",
    xaxis: {
      lines: {
        show: false,
      },
    },
  },
  legend: {
    show: false,
  },
  dataLabels: {
    enabled: false,
    offsetX: -5,
    style: {
      fontSize: "14px",
      fontWeight: 600,
      colors: ["#fff"],
    },
  },
  stroke: {
    show: true,
    width: [4, 4, 3],
    colors: ["#ffffff", "#ffffff", primary],
  },
  colors: [primary, secondary],
  tooltip: {
    shared: true,
    intersect: false,
  },
  xaxis: {
    categories: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "July", "Aug"],
    axisBorder: {
      show: false,
    },
    labels: {
      style: {
        fontFamily: "Outfit, sans-serif",
        fontWeight: 500,
        colors: "#8D8D8D",
      },
    },
  },
  yaxis: {
    labels: {
      style: {
        fontFamily: "Outfit, sans-serif",
        fontWeight: 500,
        colors: "#3D434A",
      },
    },
  },
  responsive: [
    {
      breakpoint: 1400,
      options: {
        series: [
          {
            type: "bar",
            data: [350, 180, 240, 470, 200],
          },
          {
            type: "bar",
            data: [500, 390, 280, 140, 290],
          },
          {
            type: "line",
            data: [350, 180, 240, 470, 200],
          },
        ],
      },
    },
    {
      breakpoint: 1200,
      options: {
        series: [
          {
            type: "bar",
            data: [350, 180, 240, 470, 200, 570, 300, 200],
          },
          {
            type: "bar",
            data: [500, 390, 280, 140, 290, 190, 390, 90],
          },
          {
            type: "line",
            data: [350, 180, 240, 470, 200, 570, 300, 200],
          },
        ],
        chart: {
          height: 320,
          toolbar: {
            show: false,
          },
        },
      },
    },
    {
      breakpoint: 550,
      options: {
        series: [
          {
            type: "bar",
            data: [350, 180, 240, 470],
          },
          {
            type: "bar",
            data: [500, 390, 280, 140],
          },
          {
            type: "line",
            data: [350, 180, 240, 470],
          },
        ],
      },
    },
  ],
};

// goal over view start //
export const GoalOverView: ApexOptions = {
  series: [
    {
      name: " Our Goal ",
      type: "area",
      data: [50, 40, 48, 37, 50],
    },
    {
      name: " Our Goal ",
      type: "line",
      data: [40, 50, 35, 45, 45],
    },
  ],
  chart: {
    height: 235,
    type: "line",
    toolbar: {
      show: false,
    },
  },
  stroke: {
    curve: "smooth",
    width: [3, 2],
    dashArray: [0, 5],
  },
  fill: {
    type: "solid",
    opacity: [0.2, 1],
  },
  markers: {
    size: [5, 0],
    colors: ["#fff"],
    strokeColors: [primary, secondary],
    strokeWidth: [2, 0],
  },
  yaxis: {
    show: false,
  },
  grid: {
    show: false,
  },
  xaxis: {
    labels: {
      show: false,
    },
    axisTicks: {
      show: false,
    },
  },
  tooltip: {
    shared: true,
    intersect: false,
    y: {
      formatter: function (y) {
        if (typeof y !== "undefined") {
          return y.toFixed(0) + " points";
        }
        return y;
      },
    },
  },
  legend: {
    show: false,
  },
  responsive: [
    {
      breakpoint: 1200,
      options: {
        chart: {
          height: 240,
        },
      },
    },
  ],

  colors: ["#1a5f7f", secondary],
};

export const SalesReportsLineChart: ApexOptions = {
  series: [
    {
      name: "series1",
      data: [42.5, 40, 36, 32, 28, 25, 22, 20, 18, 16.5, 15.5, 15, 15, 16, 18, 20, 23, 26, 30, 34, 38, 41.5, 45, 48, 51, 54, 56, 58, 59, 59, 58, 56.5, 54.5, 51.5, 48, 44],
    },
    {
      name: "series2",
      data: [57, 58, 58, 57.5, 56.5, 55, 52.5, 50, 47, 43.5, 40, 36, 32, 28, 24, 20, 17, 15, 14.0, 14, 15, 17, 20, 24, 28, 32, 36, 40, 44, 48, 51.5, 54.5, 56.6, 58, 58.5, 58],
    },
  ],
  chart: {
    height: 310,
    width: "100%",
    type: "line",
    offsetY: 12,
    toolbar: {
      show: false,
    },
  },
  dataLabels: {
    enabled: false,
  },
  colors: [primary, secondary],
  markers: {
    size: 5,
    strokeColors: "#fff",
    strokeWidth: 2,
    discrete: [],
    shape: "circle",
    offsetX: 0,
    offsetY: 0,
    onClick: undefined,
    onDblClick: undefined,
    showNullDataPoints: true,
    hover: {
      size: 10,
    },
  },
  stroke: {
    curve: "straight",
    lineCap: "butt",
    width: 3,
  },
  grid: {
    show: true,
    borderColor: "var(--border-light)",
    strokeDashArray: 0,
    position: "back",
    padding: {
      top: -20,
      right: 10,
      bottom: 0, 
      left: 30,
    },
  },
  yaxis: {
    logBase: 100,
    tickAmount: 6,
    min: 0,
    max: 60,
    labels: {
      show: true,
      align: "right",
      minWidth: 0,
      maxWidth: 25,
      formatter: (value) => {
        return `${value}k`;
      },
    },
  },
  xaxis: {
    type: "category",
    categories: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec", "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec", "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    tickAmount: 12,
    labels: {
      minHeight: undefined,
      maxHeight: 28,
      offsetX: 10,
      offsetY: 0,
    },
  },
  tooltip: {
    custom: function ({ series, seriesIndex, dataPointIndex, w }) {
      return `<div class="apex-tooltip"> 
                <span>
                    <span class="bg-secondary"> </span>
                      Selling : ${series[0][dataPointIndex]} K
                </span> 
                <span class="mt-2">
                    <span class="bg-primary"> </span>
                      Selling : ${series[1][dataPointIndex]} K
                </span> 
              </div>`;
    },
  },
  legend: {
    show: false,
  },
  responsive: [
    {
      breakpoint: 1200,
      options: {
        series: [
          {
            name: "series1",
            data: [42.5, 40, 36, 32, 28, 25, 22, 20, 18, 16.5, 15.5, 15, 15, 16, 18, 20, 23, 26, 30, 34, 38],
          },
          {
            name: "series2",
            data: [57, 58, 58, 57.5, 56.5, 55, 52.5, 50, 47, 43.5, 40, 36, 32, 28, 24, 20, 17, 15, 14.0, 14, 15],
          },
        ],
        chart: {
          height: 290,
        },
      },
    },
  ],
};

export const TotalSalesData = [
  { icon: <ShoppingBag className="txt-primary" />, color: "primary", title: "Total Sales", text: "54,750", chartClass: "sales-chart", chart: SalesChart },
  { icon: <DollarSign className="txt-secondary" />, color: "secondary", title: "Total Income", text: "$35,532", chartClass: "income-chart", chart: IncomeChart },
  { icon: <FileText className="txt-warning" />, color: "warning", title: "Orders Paid", text: "55,900", chartClass: "order-chart", chart: OrderChart },
  { icon: <Users className="txt-info" />, color: "info", title: "Total Visitor", text: "67,900", chartClass: "visitor-chart", chart: VisitorChart },
];

export const ManageOrderData = [
  { image: "dashboard-2/product/1.png", name: "Apple laptop", id: "#59638", date: "15/02/24", price: "$526", status: "In Stock", quantity: "12 PCS", color: "primary" },
  { image: "dashboard-2/product/2.png", name: "iPhone Pro model", id: "#65981", date: "16/02/24", price: "$835", status: "Low Stock", quantity: "09 PCS", color: "secondary" },
  { image: "dashboard-2/product/3.png", name: "Smartwatch", id: "#54739", date: "10/03/24", price: "$600", status: "In Stock", quantity: "18 PCS", color: "primary" },
  { image: "dashboard-2/product/4.png", name: "Apple AirPods", id: "#41563", date: "25/03/24", price: "$652", status: "Out of Stock", quantity: "20 PCS", color: "warning" },
];

export const ProductDeliveryData = [
  { image: "dashboard-2/product/5.png", title: "Designed T-shirts", text: "To : Vinicius Correia", badge: "Delivered", color: "primary" },
  { image: "dashboard-2/product/6.png", title: "Stillbirth Helmet", text: "To : Fabio Correia", badge: "Shipping", color: "success" },
  { image: "dashboard-2/product/7.png", title: "Hardwood Sofa", text: "To : Brenda Ferreira", badge: "Delivered", color: "primary" },
  { image: "dashboard-2/product/8.png", title: "Wireless Headphone", text: "To : Mariana Ribeiro", badge: "Confirmed", color: "warning" },
  { image: "dashboard-2/product/9.png", title: "Makeover Tube", text: "To : Rebeca Fernandes", badge: "Delivered", color: "primary" },
];

export const RecentCustomersData = [
  { image: "dashboard-2/user/1.png", title: "Agatha Azevedo", id: "ID #65249", text: "Paid", color: "success", price: "$9856.52", time: "40 min ago" },
  { image: "dashboard-2/user/2.png", title: "Rafael Rodrigues", id: "ID #54837", text: "Pending", color: "danger", price: "$4168.51", time: "28 min ago" },
  { image: "dashboard-2/user/3.png", title: "Evelyn Rocha", id: "ID #45126", text: "Paid", color: "success", price: "$2244.12", time: "20 min ago" },
  { image: "dashboard-2/user/4.png", title: "Fabio Santos", id: "ID #95124", text: "Pending", color: "danger", price: "$2538.25", time: "30 min ago" },
  { image: "dashboard-2/user/5.png", title: "Julieta Castro", id: "ID #32486", text: "Paid", color: "success", price: "$4255.85", time: "35 min ago" },
];

export const RecentOrdersData = [
  {image:"dashboard-2/product/10.png",title:"Camera Lens",text:"Canon Camera",date:"15 Jan 2025",time:"09:00 AM",customer:"Emily Fernandes",price:"$ 365.28",status:"Succeed",color:"success"},
  {image:"dashboard-2/product/11.png",title:"Black shirt",text:"Shasmi",date:"22 Feb 2025",time:"04:00 AM",customer:"Bianca Barros",price:"$ 458.20",status:"Waiting",color:"warning"},
  {image:"dashboard-2/product/12.png",title:"Argan Oil",text:"Moroccan",date:"22 Mar 2025",time:"11:30 AM",customer:"Laura Goncalves",price:"$ 218.25",status:"Succeed",color:"success"},
  {image:"dashboard-2/product/13.png",title:"Parfum",text:"Bella Vita",date:"05 Mar 2025",time:"04:22 AM",customer:"Yasmin Ribeiro",price:"$ 258.16",status:"Canceled",color:"danger"}
]